<template>
  <div v-if="visiblePanel" class="">
    <div v-if="visibleParameters" id="oceanographicParameters">
      <div class="btn-group btn-group-toggle mt-2 mb-2" data-toggle="buttons">
        <label class="btn btn-outline-primary btn-param active">
          <input @click="getData('ConOxigenoDisuelto')" type="radio" name="options" id="option1" autocomplete="off" checked> C.O.D
        </label>
        <label class="btn btn-outline-primary btn-param">
          <input @click="getData('PorOxigenoDisuelto')" type="radio" name="options" id="option2" autocomplete="off"> P.O.D
        </label>
        <label class="btn btn-outline-primary btn-param">
          <input @click="getData('Salinidad')" type="radio" name="options" id="option3" autocomplete="off"> SAL
        </label>
        <label class="btn btn-outline-primary btn-param">
          <input @click="getData('Clorofila')" type="radio" name="options" id="option4" autocomplete="off">  CLO
        </label>
      </div>
      <apexchart ref="paramChart" type="line" height="340" :options="chartOptions" :series="series"></apexchart>
    </div>
  </div>
</template>

<script>
  import {getData} from '@/services/api.js'
  import { mapGetters } from 'vuex'

  export default {
    name: 'InfoPanel',
    computed: {
        ...mapGetters(['platform_id']),
        paramsCampaignSelected: {
          get () { return this.$store.state.mapLayers.layerParams.paramsCampaignSelected }
        },
    },
    watch: {
    'platform_id': function () {

      this.loadParams()
      this.visibleParameters = true
    },
    'paramsCampaignSelected': function () {
      if(this.$refs.paramChart){
        this.loadParams()
      }
    }
  },
    data () {
      return {
          currentParam: 'ConOxigenoDisuelto',
          visiblePanel: true,
          visibleParameters: false,
          unidad: '',
          paramTitle: 'Concentración de oxígeno disuelto',
          paramBajada:[],
          paramSubida: [],
          series: [{
            name: '',
            data: []
          },{
            name: '',
            data: []
          }],
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              },
              animations: {
                enabled: true
              }
            },
            stroke: {
              width: [5,5,4],
              curve: 'straight'
            },
            tooltip: {
              enabled: true,
              custom: function({series, seriesIndex, dataPointIndex, w}) {
    return '<div class="arrow_box">' +
      '<span>' + series[seriesIndex][dataPointIndex] + '</span>' +
      '</div>'},
              inverseOrder: false,
              followCursor: true,
              x: {
                show: true
              },
              y: {
                title: 'Hola'
              },
              z: {
                title: 'Hola'
              },
              marker: {
                show: false
              }

            },
            labels: [],
            title: {
              text: this.paramTitle
            },
            xaxis: {
              type: 'numeric',

              labels: {
                show: true,
                rotate: 0,
                rotateAlways: false,
                hideOverlappingLabels: true,
                showDuplicates: false,
                trim: false,
                minHeight: undefined,
                maxHeight: 120,
                style: {
                    colors: [],
                    fontSize: '12px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                    fontWeight: 400,
                    cssClass: 'apexcharts-xaxis-label',
                },
                offsetX: 0,
                offsetY: 0,
                // format: undefined,
                formatter: function (value) {
                  return value.toFixed(3);
                }

              },
              // title: {
              //     text: this.unidad ,
              //     offsetX: 0,
              //     offsetY: 0,
              //     style: {
              //         color: '#00A7E3',
              //         fontSize: '12px',
              //         fontFamily: 'Helvetica, Arial, sans-serif',
              //         fontWeight: 600,
              //         cssClass: 'apexcharts-xaxis-title',
              //     },
              // },
            },
            yaxis: {
              type: 'numeric',
              reversed: true
            }
          },
      }
    },
    mounted () {
     // this.load()
    },
    methods: {
      loadParams() {
         var url = 'mmdata/water-parameter-data/' + this.platform_id + '/' + this.paramsCampaignSelected.id + '/'
          getData(url).then(res=> {
            this.oceanographicParameters = res.data
            this.paramSubida = []
            this.paramBajada = []

            //this.unidad = 'DO mg/L'
            //this.paramTitle = "Concentración de oxígeno disuelto"
            //this.$refs.paramChart.updateOptions({
            //    title: {
            //    text: this.paramTitle
            //  }
            //})
            //this.series = [{
            //  name: this.unidad,
            //  data: this.oceanographicParameters.ConOxigenoDisuelto
            //}]
            this.splitData(this.currentParam)
            this.fillData(this.currentParam)
        })

      },
      getData (param) {
        this.paramSubida = []
        this.paramBajada = []
        this.splitData(param)
        this.fillData(param)
      },
      splitData(param) {
        let values = []
        let bajada = true
        //let params = param
        let genericParameters = this.oceanographicParameters[param]
        //console.log('estos son los params ->', genericParameters)

        genericParameters.forEach(value => {
          values.push(parseFloat(value.y))
        })

        let maxValue = Math.max(...values)

        genericParameters.forEach(value => {
          if (parseFloat(value.y) == maxValue) {
            bajada = false
          }
          if (bajada) {
            this.paramBajada.push(Object.values(value))
          } else {
            this.paramSubida.push(Object.values(value))
          }
        })
        this.paramBajada.sort((a, b) => a.y - b.y)
        this.paramSubida.sort((a, b) => b.y - a.y)

       this.paramBajada = this.paramBajada.map(arr => {
         return arr.map(val => Number(val))
        })

        this.paramSubida = this.paramSubida.map(arr => {
         return arr.map(val => Number(val))
        })

        // console.log('param bajada --->',this.paramBajada)
        // console.log('param Subida --->',this.paramSubida)
      },
      fillData (param) {
        //console.log(param)
        switch (param) {
          case 'ConOxigenoDisuelto':
            this.currentParam = 'ConOxigenoDisuelto'
            this.unidad = 'DO mg/L'
            this.paramTitle = "Concentración de oxígeno disuelto"
            this.series = [{
              name: 'Bajada ' + this.unidad,
              data: this.paramBajada
            },
            {
              name: 'Subida ' + this.unidad,
              data: this.paramSubida
            }]
            break;
          case 'PorOxigenoDisuelto':
            this.currentParam = 'PorOxigenoDisuelto'
            this.unidad = 'DO %'
            this.paramTitle = "Porcentage de oxígeno disuelto"
            this.series = [{
              name: 'Bajada ' + this.unidad,
              data: this.paramBajada
            },
            {
              name: 'Subida ' + this.unidad,
              data: this.paramSubida
            }]
            break;
          case 'Clorofila':
            this.currentParam = 'Clorofila'
            this.unidad = 'Chl ug/L'
            this.paramTitle = "Clorofila"
            this.series = [{
              name: 'Bajada ' + this.unidad,
              data: this.paramBajada
            },
            {
              name: 'Subida ' + this.unidad,
              data: this.paramSubida
            }]
            break;
          case 'Salinidad':
            this.currentParam = 'Salinidad'
            this.unidad = 'SAL-ppt'
            this.paramTitle = "Salinidad"
            this.series = [{
              name: 'Bajada ' + this.unidad,
              data: this.paramBajada
            },
            {
              name: 'Subida ' + this.unidad,
              data: this.paramSubida
            }]
            break;
        }
        this.$refs.paramChart.updateOptions({
         title: {
          text: this.paramTitle
          }
        })

      }

    }
  }
</script>

<style>
  .btn-outline-primary:not(:disabled):not(.disabled).active, .btn-outline-primary:not(:disabled):not(.disabled):active, .show > .btn-outline-primary.dropdown-toggle {
      color: #595970;
      background-color: #e8e9e9;
      border-color: #595970;
  }
  .btn-outline-primary {
    color: #595970;
    border-color: #595970;
  }
  .btn-outline-primary:hover {
    background-color: #e8e9e9;
    border-color: #595970;
  }
  .btn-outline-primary.focus,.btn-outline-primary.active {
   outline: none !important;
   box-shadow: none;
  }
  .btn-group{
    display: flex;
    flex-direction: row;
  }
  .btn-param{
    flex: 1 1 0px;
    border: none;
    height: 30px;
    font-size: 0.8rem;
    border-bottom: 1px solid rgba(131, 131, 131, 0.2);
  }
  .btn-param:hover{
    background-color: #00A7E3;
    border-bottom: 1px solid #005773;
  }
  .btn-outline-primary{
    /*background-color: #00A7E3;
    border-bottom: 1px solid rgba(131, 131, 131, 0.2);*/
  }
  .apexcharts-title-text{
    /*color: #00A7E3;
    font-size: 0.75rem;*/
  }
</style>




// WEBPACK FOOTER //
// src/components/map/InfoPanel.vue